<template>
  <tr>
    <th>받는 사람</th>
    <td>
      {{rcpDesc}}
      <span class="bracket">({{targetTypeText}})</span>
      <button type="button" class="btn_function" @click="$emit('clickRcpListView')">목록보기</button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    rcpGroupSendYn: String,
    rcpDesc: String
  },
  computed: {
    targetTypeText() {
      return this.rcpGroupSendYn === "Y" ? "그룹전송" : "대상자별 전송";
    }
  },
};
</script>

<style>
</style>